import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import { Link } from 'react-router-dom'

import styles from './index.module.css'
import { motion, AnimatePresence } from "framer-motion";
import { wrap } from "popmotion";

const GrantIntro = () => {

	const App = useApp();
	const [ introLst, setIntroLst ] = useState([{tit: "정부지원금 혜택을 한눈에", content: `김모니님에게 꼭 맞는\n정부지원금 혜택을 찾아보아요!`}, {tit: "원스톱으로 지원금 조회하세요!", content: "복지로, 보조금24 지원금까지\n조회가능해요!"}]);
	const [[page, direction], setPage] = useState([0, 0]);
	
	const variants = {
		enter: (direction: number) => {
		  return {
			x: direction > 0 ? 1000 : -1000,
		  };
		},
		center: {
		  zIndex: 1,
		  x: 0,
		},
		exit: (direction: number) => {
		  return {
			zIndex: 0,
			x: direction < 0 ? 1000 : -1000,
		  };
		}
	};

	const swipeConfidenceThreshold = 10000;
	const swipePower = (offset: number, velocity: number) => {
		return Math.abs(offset) * velocity;
	};

	const list = introLst.map((intro, index)=> <InfoSliderList key={index} intro={intro} />);
	const imageIndex = wrap(0, list.length, page);
	
	const paginate = (newDirection) => {
		if ( (page + newDirection) < 0 ){
			return true;
		} else if ( (page + newDirection) > (list.length - 1) ){
			return true;
		}
		setPage([page + newDirection, newDirection]);
	};

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})
		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_ 1 padding center-cont">
				<div className={`slider ${styles.grtSlider}`}>
					<AnimatePresence initial={false} custom={direction}>
						<motion.ul
							key={page}
							children={list[imageIndex]}
							custom={direction}
							variants={variants}
							initial="enter"
							animate="center"
							exit="exit"
							className={styles.grtIntroList}
							transition={{
								x: {
									type: "spring", 
									stiffness: 300, 
									damping: 30 
								},
								opacity: { 
									duration: 0.2 
								}
							}}
							drag="x"
							dragConstraints={{ left: 0, right: 0 }}
							dragElastic={1}
							onDragEnd={(e, { offset, velocity }) => {
								const swipe = swipePower(offset.x, velocity.x);
								if (swipe < -swipeConfidenceThreshold) {
									paginate(1);
								} else if (swipe > swipeConfidenceThreshold) {
									paginate(-1);
								}
							}}
						/>
					</AnimatePresence>
					<ul className="slider-dots dots-gray" style={{ paddingTop: "36.3rem" }}>
						{ list.map((item, index) => <li key={index} className={index === page ? 'active' : ''} />) }
					</ul>			
				</div>
			</div>
			<div className="padding flex-shrink_0">
				<Link to="/life/grantSecurity"><Button className="btn btn--big">시작하기</Button></Link>
			</div>
		</div>
	)
}

const InfoSliderList = ({ intro }) => {
	const { tit, content } = intro;
	return (
		<li>
			<i className="icon icon_gift_object" />
			<h3 className="intro-tit mt_20">{tit}</h3>
			<p className="intro-sub-tit mt_10" style={{ whiteSpace: "pre-wrap" }}>{content}</p>
		</li>
	)
}

export default GrantIntro
